// this utility determines what buttons are shown on tinyMCE's toolbar and in what order
// see documentation for toolbar options: https://www.tiny.cloud/docs/configure/editor-appearance/#toolbar
// see documentation for available buttons: https://www.tiny.cloud/docs/advanced/available-toolbar-buttons/#thecoretoolbarbuttons

const firstLayer =
  'bold italic underline strikethrough |' +
  'fontsizeselect customFontSize | ' +
  'customFontSelect | ' +
  'lineheight customLineSpace | ' +
  'kerning | ' +
  'table |' +
  'hr |' +
  'selectall |'

const secondLayer =
  'forecolor backcolor |' +
  'alignleft aligncenter alignright alignjustify | ' +
  'dynamicText | customdeceasedname | casing | outline | outlineColor | ' +
  'undo redo | ' +
  'removeformat'

export const toolbarSettings = (inline) =>
  inline ? [firstLayer, secondLayer] : `${firstLayer}${secondLayer}`

export default toolbarSettings
